const BaseComponent = require('base/base-component');
const Util = require('helper/util');

class headNav extends BaseComponent {
  init () {
    this.float = this.$el.find('[name=isFloat]').val();
    this.$container = this.$el.find('.float-container');
    this.offsetTop = this.$el.offset().top;
    if (!Util.isIE(8)) {
      this.$el.find('.js-head-menu').lavalamp({
        easing: 'easeOutBack'
      });
    }

    /* 头部浮动 */
    if (this.float && this.float !== 'missing helper') {
      $(window).on('scroll', () => this.floatNav());
    }
  }

  floatNav () {
    const _scrollTop = $(document).scrollTop();
    if (_scrollTop > this.offsetTop) {
      this.$container.addClass('floating');
    } else {
      this.$container.removeClass('floating');
    }
  }
}
module.exports = headNav;
